import { __assign, __makeTemplateObject, __rest } from "tslib";
import map from 'lodash/map';
import * as React from 'react';
import styled from 'styled-components';
import asRendition from '../../asRendition';
import { DismissableContainer } from '../../internal/DismissableContainer';
import { Box } from '../Box';
import { Divider } from '../Divider';
import { Flex } from '../Flex';
import { Heading } from '../Heading';
import { useBreakpoint } from '../../hooks/useBreakpoint';
var Wrapper = styled(DismissableContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t& {\n\t\tpadding: ", ";\n\t}\n"], ["\n\t& {\n\t\tpadding: ", ";\n\t}\n"])), function (props) { return (props.small ? '24px' : '32px 44px'); });
var BaseCard = function (_a) {
    var title = _a.title, cta = _a.cta, rows = _a.rows, children = _a.children, small = _a.small, props = __rest(_a, ["title", "cta", "rows", "children", "small"]);
    var hasHeader = title || cta;
    var isSmall = useBreakpoint(small);
    var Header = hasHeader && (React.createElement(React.Fragment, null,
        React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
            React.createElement(Heading.h5, { fontSize: 4 }, title),
            cta),
        React.createElement(Divider, { my: 2 })));
    var Rows = rows &&
        map(rows, function (row, index) { return (React.createElement(Box, { key: index, fontSize: 2 },
            index > 0 && React.createElement(Divider, null),
            row)); });
    var Body = children && (React.createElement(Box, { fontSize: 2, height: "100%" }, children));
    return (React.createElement(Wrapper, __assign({ small: isSmall }, props),
        React.createElement(Box, { width: "100%" },
            Header,
            Rows,
            Body)));
};
export var Card = asRendition(BaseCard);
var templateObject_1;
